import React from 'react';
import { Link } from 'react-router-dom';

// Button
import { Button } from 'antd';

// Internals
import FullPageSplash from '../components/FullPageSplash';
import IMAGE from '../img/pages/contact-us/image.png';

// Icons
import { ArrowLeft } from 'react-feather';

export default function ContactUs() {
  return (
    <FullPageSplash
      actions={
        <>
          <Link to="/">
            <Button size="large">
              <ArrowLeft style={{ marginTop: '-0.15rem' }} />
              Go back
            </Button>
          </Link>
        </>
      }
      backgroundStyles={{
        backgroundImage: `url(${IMAGE})`,
      }}
      title="Contact Us"
      subTitle={
        <>
          Please email us directly at <b>hi@integral.xyz</b> and tell us exactly what you need help
          with. One of us will reply to you as fast as possible!
        </>
      }
    />
  );
}
